import SlideInAnimation from '@/components/SlideInAnimation'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FloatingInspectorButtonIconAndText } from '../../FloatingInspectorButton/FloatingInspectorButtons'
import WrappingFloatingInspectorCyanPurple from '../../FloatingInspectorButton/SharedComponents/WrappingFloatingInspector/WrappingFloatingInspectorCyanPurple'
import RotateLoadingIcon from '@/components/icons/RotateLoadingIcon'

interface EditWithAIFloatingLoaderProps {
  loaderLabel?: string
  show?: boolean
  maxWidth?: number
}
const DURATION_ANIMATION = 2000

export default function EditWithAIFloatingLoader({ loaderLabel, show, maxWidth }: EditWithAIFloatingLoaderProps) {
  const { t } = useTranslation()
  const firstText = t('Thinking...')
  const [text, setText] = useState(firstText)
  useEffect(() => {
    if (!show) return

    const timeoutId = setTimeout(() => {
      setText(loaderLabel || firstText)
    }, DURATION_ANIMATION)

    return () => {
      setText(firstText)
      clearTimeout(timeoutId)
    }
  }, [loaderLabel, show, firstText])
  return (
    <SlideInAnimation isVisible={show} direction="up" hideWithAnimation={false}>
      <WrappingFloatingInspectorCyanPurple
        rounded="round"
        style={{
          width: 'fit-content',
          maxWidth: maxWidth ? `${maxWidth}px` : undefined,
          position: 'relative',
        }}
      >
        <FloatingInspectorButtonIconAndText
          text={text}
          icon={<RotateLoadingIcon />}
          onClick={() => {}}
          showText
          tooltipText={text}
          nonInteractive
          fontWeight={400}
          style={{
            gap: '4px'
          }}
        />
      </WrappingFloatingInspectorCyanPurple>
    </SlideInAnimation>
  )
}
